module.exports = __webpack_public_path__ + "ce6de835ac882df1be6c457fe751ea90.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/large-0.png
// module id = 2170
// module chunks = 0